import { Injectable, inject } from '@angular/core';

import { BooktechAppService, MiscUtil } from '@btlib-core';

import { BergensportsreiserService } from './bergensportsreiser.service';
import { SportstravelService } from './sportstravel.service';

export const APP_DATAID = {

}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  name = "AppService"

  

  public bas = inject(BooktechAppService);
  bss:BergensportsreiserService|undefined;
  sts:SportstravelService|undefined;

  constructor() {
    if(this.bas.envtest) console.log("AppService: ", this.bas.settings?.appId);

    let cid = this.bas.ds.findCid();
    let fc = this.bas.ds.findCompany(true);
    let tsInit = true; 

    if (cid == "bergensportsreiser") {
      tsInit = false;
      this.bss = new BergensportsreiserService(this);
    } else if (cid == "sportstravel" || fc?.upCmSportstravel) {
      this.sts = new SportstravelService(this); //TODO
    } else {
    

  
    }

    if (tsInit) {
    
      let gtmId = this.bas.envtest ? fc?.gtmIdTest :  fc?.gtmIdProd;
      let pixelId = this.bas.envtest ? fc?.pixelIdTest :  fc?.pixelIdProd;
      if (!gtmId && this.bas.envtest) gtmId = "GTM-NQL4QB4F";  // app.test.cloudbooking.io

      let tsConfig:any = {
        klaro: fc?.cbappProps?.klaroEnabled ?? false,
        cb: {
          enabled: fc?.cbappProps?.trackCbEnabled ?? false
        },
        gtm: {
          enabled: !!gtmId,
          id: gtmId
        },
        pixel: {
          enabled: !!pixelId,
          id: pixelId
        }
      };



      if(this.bas.envtest)   console.log(MiscUtil.getLogText("AppService, tsConfig: ", tsConfig));

      if (this.bas.nossr) {

        this.bas.ts.init(tsConfig);
      }

    }
    
  }

}
